<p *ngIf="error" role="alert" class="text-danger">{{ error }}</p>
<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <tt-select ttLabel="sub_resource" [(ttModel)]="page.resource_id_belongto" [ttData]="subResources" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-input ttLabel="resource_id" [ttModel]="page.resource_id" ttReadonly></tt-input>
        <tt-input ttLabel="resource_name" [(ttModel)]="page.resource_name"></tt-input>
        <tt-input-number ttLabel="frr_id" [(ttModel)]="page.frr_id" ttDecimals="0" ttFormatNumber ttAutoSelect>
            <ng-container buttons>
                <tt-form-field-button ttIcon="fas fa-calculator" [ttDisabled]="calculating" (ttClick)="calculateFrrId()"></tt-form-field-button>
            </ng-container>
        </tt-input-number>
        <tt-input ttLabel="special_prod_name_view" [ttModel]="page.special_prod_name_view" ttReadonly></tt-input>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="page.activeproduct"></tt-checkbox>
        <tt-button-save ttText="srresource_save" [ttLoading]="saving" (ttClick)="save()" ttTextAlign="center"></tt-button-save>
    </tt-card>
</tt-page>
